<template>
  <div>
    <div
      class="form-panel"
      style="width: auto; margin: 0px 0px 0px 0px; height: 10%"
    >
      <button class="fixed-button" @click="noticeDrawer=true">
        <i class="el-icon-document mr5"></i>填表说明
      </button>
      <iframe
        class="biframe"
        :src="fromsUrl"
        id="iframeId2"
        style="width: 100%; border: 0; height: 900px"
      >
      </iframe>
    </div>
    <!-- 填表说明 -->
    <el-drawer title="填表说明" :visible.sync="noticeDrawer" :modal="true" :wrapper-closable="false"
                center size="60%" :show-close="true">
      <fillingExplanation ref="noticePage"/>
    </el-drawer>
  </div>
</template>

<script>
// import {webutils} from 'zfgl-utils'
import { declareRequirement,getPublicPlanInfo} from "@/api/collect/collect-api.js";
import fillingExplanation from "@/views/collect/component/fillingExplanation";
export default {
  components: {fillingExplanation},
  data() {
    return {
      fromsUrl: "",
      planId: "",
      noticeDrawer: false
    };
  },
  created() {
    const url = window.location.href; // 获取当前url
    let cs = url.split("?")[1];
    let planId = cs.split("=")[1];
    this.planId = planId;
    console.log("this.planId")
    console.log(this.planId)
    this.collectNeedFrom(planId);
  },
  mounted() {
    window.parent.removeEventListener("message", this.handleMessage);
    window.addEventListener("message", this.handleMessage);
  },
  destroyed() {
    //移除监听
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    collectNeedFrom(val) {
      getPublicPlanInfo(val).then(res=>{
        if (!res.data && !res.data.formUrl) {
          this.$message.error("当前计划未关联表单");
        } else if (!res.data && 'verified' != res.data.verifyTimeFlag) {
          this.$message.error("当前计划不在填报期内");
        } else {
          this.fromsUrl = res.data.formUrl + '&planId=' + res.data.planId
        }
      })
    },
    handleMessage(e) {
      if (e.data&&e.data.formId) {
        console.log("handleMessage1:")
        console.log(e)
        declareRequirement(e.data)
          .then((data) => {
            this.$message.success("提交成功");
            window.removeEventListener("message", this.handleMessage);
          })
          .catch((error) => {
            // this.$message.error(webutils.parseErrorMsg(error, "提交失败"));
            window.removeEventListener("message", this.handleMessage);
          });
      }
    },
  },
};
</script>

  <style lang="scss" scoped>
  //@import "~@style/_var";
  .form-panel {
    width: calc(100vw - 420px);
    height: calc(100vh - 320px);
    margin: 20px 50px 20px 50px;
  }

  .btn-panel {
    margin: 20px;
    text-align: center;
  }

  .upload-panel {
    width: calc(100vw - 420px);
    height: calc(100vh - 320px);
    overflow: auto;
  }

  .biframe {
    width: calc(100vw - 420px);
    height: calc(100vh - 320px);
    border: 0;
  }
  .fixed-button {
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 10px 20px;
    border-radius: 4px;
    background-color: #007BFF;
    color: white;
    border: none;
    cursor: pointer;
  }
  </style>
